export default __webpack_public_path__ + "locales/pt-BR/Settings.json?hash=e844e410188b8bd4384dcef9fb391dbb";